var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmokingSometimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.63,
    height: 33.926,
    viewBox: "0 0 34.63 33.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_96",
    "data-name": "Gruppe 96",
    transform: "translate(-909.153 -1201.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kippe",
    transform: "translate(909.653 1227.967)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_77",
    "data-name": "Rechteck 77",
    width: 1.543,
    height: 6.843,
    transform: "translate(30.161)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_2",
    "data-name": "Vereinigungsmenge 2",
    d: "M26.179,6.749H0V0H27.77V6.749Z",
    transform: "translate(0 0.095)",
    fill: "#454545",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_78",
    "data-name": "Rechteck 78",
    width: 1.544,
    height: 6.843,
    transform: "translate(32.587)",
    fill: "#454545"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_661",
    "data-name": "Pfad 661",
    d: "M3.848-6.4h4.29a21.215,21.215,0,0,1,2.886-3.12c1.638-1.664,2.21-2.912,2.21-4.654,0-2.418-1.768-4.446-4.914-4.446A11.438,11.438,0,0,0,3.614-17.55L2.6-13.156a6.388,6.388,0,0,1,3.666-1.352c1.222,0,1.9.546,1.9,1.482A3.61,3.61,0,0,1,6.838-10.5C4.914-8.476,4.056-7.332,3.848-6.4ZM4.81.078A2.9,2.9,0,0,0,7.8-3.094,1.84,1.84,0,0,0,5.694-5.07,2.957,2.957,0,0,0,2.6-1.846C2.6-.416,3.354.078,4.81.078Z",
    transform: "translate(920.342 1220)",
    fill: "#454545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokingSometimes);
export default __webpack_public_path__ + "static/media/smoking-sometimes.14efa9c8cfa66f6e14130ed11919f0ff.svg";
export { ForwardRef as ReactComponent };